function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "\\u672A\\u547D\\u540D\\u6F38\\u5C64_2",
  x1: 7.074,
  y1: 300.228,
  x2: 58.137,
  y2: 351.305,
  gradientTransform: "translate(0 -293.11)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#ffbaba"
}), React.createElement("stop", {
  offset: 0.3,
  stopColor: "#e89194"
}), React.createElement("stop", {
  offset: 0.77,
  stopColor: "#c7555d"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ba3e48"
})), React.createElement("linearGradient", {
  id: "\\u672A\\u547D\\u540D\\u6F38\\u5C64_3",
  x1: 31.891,
  y1: 296.334,
  x2: 31.891,
  y2: 356.118,
  gradientTransform: "translate(0 -293.11)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#fd936b"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fd666b"
})), React.createElement("clipPath", {
  id: "clip-path"
}, React.createElement("path", {
  d: "M62.716,32c0,10.939-2.231,18.655-7.2,23.613s-12.689,7.22-23.628,7.22S13.331,60.6,8.357,55.643,1.065,42.968,1.065,32,3.355,13.36,8.328,8.387s12.689-7.22,23.614-7.22,18.625,2.231,23.6,7.19S62.716,21.046,62.716,32Z",
  fill: "none"
})), React.createElement("linearGradient", {
  id: "\\u672A\\u547D\\u540D\\u6F38\\u5C64_4",
  x1: 40.874,
  y1: 319.514,
  x2: 61.132,
  y2: 382.245,
  gradientTransform: "translate(0 -293.11)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.1,
  stopColor: "#231815",
  stopOpacity: 0.4
}), React.createElement("stop", {
  offset: 0.55,
  stopColor: "#231815",
  stopOpacity: 0.1
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u53C3\\u8003"
}, React.createElement("g", {
  id: "\\u5716\\u5C64_2",
  "data-name": "\\u5716\\u5C64 2"
}, React.createElement("g", {
  id: "\\u6309\\u9215\\u5B57-2",
  "data-name": "\\u6309\\u9215\\u5B57"
}, React.createElement("g", {
  id: "Restore"
}, React.createElement("g", {
  id: "Restore-2"
}, React.createElement("path", {
  d: "M56.416,7.468C51.3,2.377,43.522,0,31.942,0S12.572,2.377,7.453,7.511,0,20.419,0,32,2.334,51.413,7.482,56.532,20.419,64,31.942,64s19.383-2.377,24.5-7.511S63.956,43.6,63.956,32,61.55,12.587,56.416,7.468Z",
  fill: "url(#\\u672A\\u547D\\u540D\\u6F38\\u5C64_2)"
}), React.createElement("path", {
  d: "M62.716,32c0,10.939-2.231,18.655-7.2,23.613s-12.689,7.22-23.628,7.22S13.331,60.6,8.357,55.643,1.065,42.968,1.065,32,3.355,13.36,8.328,8.387s12.689-7.22,23.614-7.22,18.625,2.231,23.6,7.19S62.716,21.046,62.716,32Z",
  fill: "url(#\\u672A\\u547D\\u540D\\u6F38\\u5C64_3)"
})), React.createElement("g", {
  clipPath: "url(#clip-path)"
}, React.createElement("path", {
  d: "M45.477,20.784A17.5,17.5,0,1,0,20.419,45.111h0L53.965,78.76l24.8-24.795Z",
  fill: "url(#\\u672A\\u547D\\u540D\\u6F38\\u5C64_4)"
}), React.createElement("path", {
  d: "M49.444,31.971A17.5,17.5,0,0,1,20.959,45.623a1.707,1.707,0,0,1-.226-2.4c.031-.036.063-.071.095-.106l.8-.788a1.678,1.678,0,0,1,2.246-.146,12.981,12.981,0,1,0-.831-19.647l3.588,3.588a1.123,1.123,0,0,1-.8,1.925H15.621a1.137,1.137,0,0,1-1.138-1.123V16.713a1.138,1.138,0,0,1,1.94-.787L19.894,19.4a17.5,17.5,0,0,1,29.55,12.574ZM36.682,37.528l.7-.89a1.69,1.69,0,0,0-.3-2.373l0,0-2.917-2.232V24.664a1.691,1.691,0,0,0-1.692-1.692H31.344a1.691,1.691,0,0,0-1.692,1.692v9.568l4.609,3.588a1.68,1.68,0,0,0,2.363-.216C36.644,37.579,36.663,37.554,36.682,37.528Z",
  fill: "#fff"
}))))));

var SvgReduction = function SvgReduction(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgReduction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reduction.be73d4e8.svg";
export { ForwardRef as ReactComponent };